import { ReactText } from 'react';

export const priceCommaReplacer = (value: ReactText): string =>
  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
